export enum SuperAdminPrivilege {
  roomInspector = 'roomInspector',
  userInspector = 'userInspector',
  canViewFeatureFlags = 'canViewFeatureFlags',
  canInvokeEmailTemplateHandler = 'canInvokeEmailTemplateHandler',
  canEditClickwraps = 'canEditClickwraps',

  /** allow editing the codeless access toggle on sections and organizations */
  canEditCodelessAccess = 'canEditCodelessAccess',

  /** allow editing section start/end dates at any time, even with enrolled participants or on LMS-linked sections */
  canEditSectionDates = 'canEditSectionDates',

  // prompt related privileges
  canEditOutputPrompt = 'canEditOutputPrompt',
  canInstallPrompts = 'canInstallPrompts',

  /** override promotion rules if the user has this privilege and applying special admin approvedFree promo */
  canAlwaysApplyAdminApprovedFreePromotion = 'canAlwaysApplyAdminApprovedFreePromotion',

  /** allow granting the externalCanDemo capability to users */
  canGrantExternalDemo = 'canGrantExternalDemo',

  /** show the Postgres-backed Gradebook API tab alongside the Firestore gradebook */
  canViewGradebookApi = 'canViewGradebookApi',
}
